export interface collectionRight {
  role: string;
  firstName: string;
  lastName: string;
  document: File | null;
}

export interface UploadMusic {
  title: string;
  description: string;
  crew_credits: string;
  genre: {
    value: string;
    label: string;
  };
  second_genre: {
    value: string;
    label: string;
  };
  artist_name: string;
  media: File | null;
  thumbnail_image: File | null;
  multipleOwners: boolean;
  // license: File | null;
  // collectionRights array of files or null
  collectionRights: collectionRight[];
  signature: File | null;
  audio_track: string;
  thumbnail_img: string;
  signatureUrl: string;
  duration: number;
}

export const INITIAL_STATE = {
  title: '',
  description: '',
  crew_credits: '',
  multipleOwners: false,
  genre: {
    value: '',
    label: '',
  },
  second_genre: {
    value: '',
    label: '',
  },
  artist_name: '',
  media: null,
  thumbnail_image: null,
  // license: null,
  signature: null,
  audio_track: '',
  thumbnail_img: '',
  signatureUrl: '',
  collectionRights: [
    {
      role: '',
      firstName: '',
      lastName: '',
      document: null,
    },
  ],
  duration: 0,
};

export interface UploadMusicError {
  audio?: File | null;
  title?: string;
  description?: string;
  artistName?: string;
  songGenre?: string;
  thumbnail?: File | null;
  thumbnailUrl?: string;
  document?: File | null;
}
